// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"a98442e9","1371":"0cab1f3f","3550":"df8ea496","3854":"4c6748c8","4600":"d9873a9b","5364":"410d3e02","6615":"2f7b96b5","8651":"64d0ba61","9916":"58d74373"}[chunkId] + ".chunk.css";
};